module.exports = ":host {\n\tmax-height: calc(100% - var(--top-bar-height) - 1em);\n\toverflow: auto;\n}\n#old-kc-link img {\n\theight: auto;\n}\n"